import { id } from '@monorepo/tools/src/lib/types/primitives';
import { ICrudEndpoints } from '@monorepo/tools/src/lib/interfaces/crud';
import { getManagementApiBaseUrl } from '../../utils/management-api';

export class CrudEndpoint implements ICrudEndpoints {
	public rootApi: string;
	public component: string;
	public baseUrl: string;

	constructor(component: string) {
		this.rootApi = getManagementApiBaseUrl();
		this.component = component;
		this.baseUrl = `${this.rootApi}/${this.component}`;
	}

	list() {
		return this.baseUrl;
	}

	create() {
		return `${this.rootApi}/${this.component}`;
	}

	get(id: id) {
		return `${this.baseUrl}/${id}`;
	}

	edit(id: id) {
		return `${this.baseUrl}/${id}`;
	}

	delete(id: id) {
		return `${this.baseUrl}/${id}`;
	}
}
